import ProductModel from "../../Models/PorductModel";

const createProductKey = (product: any) => {
  let key = `id:${product.id}`;

  // معالجة الخيارات المختارة (option array)
  if (product.option && product.option.length > 0) {
    // تجميع الخيارات حسب option.id
    const optionsMap = new Map<number, number[]>();
    
    product.option.forEach((opt: any) => {
      if (opt.option && opt.option.id && opt.subOption && opt.subOption.id) {
        const optionId = opt.option.id;
        const subOptionId = opt.subOption.id;
        
        if (!optionsMap.has(optionId)) {
          optionsMap.set(optionId, []);
        }
        optionsMap.get(optionId)!.push(subOptionId);
      }
    });
    
    // إنشاء المفتاح مع ترتيب الخيارات
    const sortedOptionIds = Array.from(optionsMap.keys()).sort((a, b) => a - b);
    sortedOptionIds.forEach((optionId) => {
      const subOptionIds = optionsMap.get(optionId)!.sort((a, b) => a - b);
      key += `|option:${optionId}-subOptions:${subOptionIds.join(',')}`;
    });
  }

  // إضافة الملاحظة إذا كانت موجودة
  if (product && product.note && product.note.trim() !== '') {
    key += `|note:${product.note.trim()}`;
  }
  
  return key;
};

export const AddToCart = ({
  element,
  params,
  navigate,
  t,
  quantity,
  handleAddedToCartNotice,
}: any) => {
  const cart =
    JSON.parse(localStorage.getItem(`cart${params.branch_id}`) ?? "[]") || [];

  const newProductKey = createProductKey(element);
  const existingProductIndex = cart.findIndex(
    (item: any) => createProductKey(item) === newProductKey
  );

  if (existingProductIndex !== -1) {
    cart[existingProductIndex].amount += quantity; // زيادة الكمية إذا كان المنتج موجودًا
  } else {
    cart.push({ ...element, amount: quantity });
  }

  localStorage.setItem(`cart${params.branch_id}`, JSON.stringify(cart));

  window.dispatchEvent(new Event("cart-updated"));
};

export const updateQuantity = (
  product: ProductModel,
  newQuantity: number,
  branch_id: number
) => {
  const cart =
    JSON.parse(localStorage.getItem(`cart${branch_id}`) ?? "[]") || [];

  const productKey = createProductKey(product);

  const updatedCart = cart.map((item: any) => {
    if (createProductKey(item) === productKey) {
      return { ...item, amount: newQuantity };
    }
    return item;
  });

  localStorage.setItem(`cart${branch_id}`, JSON.stringify(updatedCart));
  window.dispatchEvent(new Event("cart-updated"));
};
export const removeFromCart = (product: ProductModel, branch_id: number) => {
  const cart =
    JSON.parse(localStorage.getItem(`cart${branch_id}`) ?? "[]") || [];

  const productKey = createProductKey(product);

  const updatedCart = cart.filter(
    (item: any) => createProductKey(item) !== productKey
  );

  localStorage.setItem(`cart${branch_id}`, JSON.stringify(updatedCart));
  window.dispatchEvent(new Event("cart-updated"));
};

export const getCartItems = (branch_id: number) => {
  // استرجاع السلة من localStorage
  const cart = localStorage.getItem(`cart${branch_id}`);
  return cart ? JSON.parse(cart) : []; // إذا لم تكن السلة موجودة، تعيد مصفوفة فارغة
};

export const calculateTotal = (branch_id: number) => {
  // استرجاع السلة من localStorage
  const cart = localStorage.getItem(`cart${branch_id}`);
  const cartArray = cart ? JSON.parse(cart) : [];

  // حساب الإجمالي
  const total = cartArray.reduce((acc: number, item: any) => {
    // سعر المنتج الأساسي
    let itemTotal = item.price;

    // إضافة أسعار الخيارات المختارة
    if (item.option && item.option.length > 0) {
      item.option.forEach((opt: any) => {
        if (opt.subOption) {
          itemTotal += opt.subOption.price;
        }
      });
    }

    // مضاعفة المجموع حسب الكمية
    itemTotal *= item.amount;

    return acc + itemTotal;
  }, 0);

  return total;
};

export const CalcQuantity = (branch_id: number) => {
  const qantity = JSON.parse(
    localStorage.getItem("cart" + branch_id) ?? "[]"
  ).reduce((acc: number, item: any) => acc + item.amount, 0);

  return qantity;
};

/**
 * تحديث أسعار المنتجات في السلة بناءً على البيانات الحالية من API
 * تحدث الأسعار فقط (price, price_offer) دون تغيير الكمية أو الخيارات
 */
export const updateCartPrices = async (
  branch_id: number,
  selectedProductService: (payload: { ids: number[] }) => Promise<any>
): Promise<void> => {
  const cart = getCartItems(branch_id);
  if (!cart || cart.length === 0) return;

  // استخراج IDs فريدة من المنتجات في السلة
  const productIds = [...new Set(cart.map((item: any) => item.id))];

  try {
    // جلب أحدث بيانات الأسعار من API
    const response = await selectedProductService({ ids: productIds as number[] });
    const updatedProducts = response.data.data || [];

    // إنشاء خريطة للبحث السريع
    const productsMap = new Map(
      updatedProducts.map((product: any) => [product.id, product])
    );

    // تحديث الأسعار فقط في السلة
    const updatedCart = cart.map((item: any) => {
      const updatedProduct: any = productsMap.get(item.id);
      if (updatedProduct && 'price' in updatedProduct) {
        return {
          ...item,
          price: Number(updatedProduct.price) || item.price,
          price_offer: Number(updatedProduct.price_offer) || 0,
        };
      }
      return item;
    });

    // حفظ السلة المحدثة
    localStorage.setItem(`cart${branch_id}`, JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("cart-updated"));
  } catch (error) {
    console.error("Error updating cart prices:", error);
    // في حالة الخطأ، لا نحدث السلة ونتركها كما هي
  }
};
